document.addEventListener("DOMContentLoaded", () => {
  const section  = document.querySelector(".block-two-columns-timeline");
  const timeline = section?.querySelector(".timeline");
  const wrapper  = section?.querySelector(".content-wrapper");
  const branches = Array.from(section?.querySelectorAll(".branch") || []);

  if (!section || !timeline || !wrapper) return;

  // 4rem in px (pb-16)
  const REM = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
  const END_OFFSET = 4 * REM;

  const BRANCH_BUFFER_PX = 0;
  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

  // init branch state
  branches.forEach(b => {
    b.dataset.active = b.dataset.active || "false";
    b.style.width = b.style.width || "0%";
  });

  // rAF throttle
  let ticking = false;
  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      updateTimeline();
      ticking = false;
    });
  }

  function getTrackHeight() {
    const rows = section.querySelectorAll(".block-two-columns-timeline-row");
    if (!rows.length) return 0;

    const lastRow = rows[rows.length - 1];

    // bottom of last row in WRAPPER coordinates (px from wrapper top)
    // This avoids wrapper.offsetHeight being "too tall"
    return lastRow.offsetTop + lastRow.offsetHeight;
  }

  function updateTimeline() {
    const scrollY = window.scrollY || window.pageYOffset;
    const winH = window.innerHeight;

    const wrapperTop = wrapper.getBoundingClientRect().top + scrollY;

    // This is the max raw line travel (down to the last row bottom)
    const trackHeight = getTrackHeight();
    if (trackHeight <= 0) return;

    // Scroll mapping range (tweak 0.4 if you want earlier/later)
    const start = wrapperTop - winH * 0.6;
    const end   = wrapperTop + trackHeight - winH * 0.6;

    const progress = clamp((scrollY - start) / (end - start), 0, 1);

    // raw line position (for branch triggers)
    const rawHeight = progress * trackHeight;
    const finalHeight = Math.max(0, rawHeight - END_OFFSET);

    // visible line stops 4rem earlier (so it doesn't enter pb-16)
    const visibleHeight = Math.max(0, rawHeight - END_OFFSET);

    gsap.to(timeline, {
      height: Math.max(0, finalHeight - END_OFFSET),
      duration: 0.35,
      ease: "power1.out"
    });

    // Branch reveal uses RAW height so the last branch can still trigger
    branches.forEach(branch => {
      const branchY = branch.getBoundingClientRect().top + scrollY - wrapperTop + END_OFFSET;
      const isActive = branch.dataset.active === "true";

      if (!isActive && rawHeight >= branchY + BRANCH_BUFFER_PX) {
        branch.dataset.active = "true";
        gsap.to(branch, { width: "50%", duration: 0.6, ease: "power2.out" });
      } else if (isActive && rawHeight < branchY - BRANCH_BUFFER_PX) {
        branch.dataset.active = "false";
        gsap.to(branch, { width: "0%", duration: 0.4, ease: "power2.in" });
      }
    });
  }

  window.addEventListener("scroll", requestUpdate, { passive: true });
  window.addEventListener("resize", requestUpdate);

  timeline.style.height = "0px";
  updateTimeline();
});